import React from 'react';
import clsx from 'clsx';
import styles from './Button.module.scss';

type Props = {
  type?: 'button' | 'submit' | 'reset' | undefined;
  disabled?: boolean;
  title?: string;
  className?: string;
  variant?: 'primary' | 'cancel' | 'icon' | 'hamburger' | 'edit';
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
};

const Button = React.forwardRef<HTMLButtonElement, Props>((props, ref): JSX.Element => {
  const {
    type = 'button',
    disabled = false,
    className,
    variant = 'primary',
    children,
    onClick,
    ...other
  } = props;

  return (
    <button
      ref={ref}
      type={type}
      disabled={disabled}
      className={clsx(styles[variant], className)}
      onClick={onClick}
      {...other}
    >
      {children}
    </button>
  );
});

export default React.memo(Button);
